import { apiUrl } from "@/api/config";
export class TranslationService {
    constructor() {
        this.baseUrl = apiUrl("/translations/");
    }
    async getTranslations(dealerId, componentName) {
        try {
            const response = await fetch(`${this.baseUrl}${dealerId}/${componentName}`);
            if (response.ok) {
                return await response.json();
            }
            console.error("error fetching translations", response.statusText);
        }
        catch (error) {
            console.error("error fetching translations", error);
        }
        return { resources: {} };
    }
}
